import React, { Component } from "react";
import { FiChevronLeft, FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import checkLength from "../../utils/check_length";

class OrderBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
    };
  }

  render() {
    return (
      <div className="row mx-0 p-0 rounded14 mb-3 shadow">
        <div className="col-12 fw-bolder fs-4 px-2 py-3 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto px-1 align-self-center">
              <Image
                imageUri={
                  this.props.order.shop
                    ? this.props.order.shop.cover &&
                      this.props.order.shop.cover.thumbnail
                    : this.props.order.user.image
                }
                isProfile={true}
                imageHeight={"50"}
                imageWidth={"50"}
                imgClassName={"rounded-circle img-cover"}
                extraClassName={"p-0 img-contain rounded-0"}
              />
            </div>
            <div className="col px-1 align-self-center">
              <p className="fw-bolder mb-0 fs-6">
                {this.props.order.shop
                  ? checkLength(this.props.order.shop.title, 15)
                  : this.props.order.user.name}
                {this.props.order.shop && this.props.order.shop.is_verify && (
                  <img
                    width="15"
                    className="me-1"
                    alt="verify"
                    src={
                      require("../../../base/assets/icons/verify.svg").default
                    }
                  />
                )}
              </p>
              <p className="fw-bolder mb-0 fs-7 text-muted">
                {this.props.order.created}
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <p className="fs-6 fw-bold text-start mb-1">
                <span>{this.props.order.payable_price.title}</span>
                <span className="fs-7 me-1">
                  {this.props.order.payable_price.currency}
                </span>
              </p>
              <p
                className={`fw-bold mb-0 fs-6 text-start ${
                  (this.props.order.status || this.props.order.status === 0) &&
                  (this.props.order.status === 5
                    ? "text-danger"
                    : this.props.order.status === 0
                    ? "color-second"
                    : "text-muted")
                }`}
              >
                {this.props.order.status_obj.text}
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 fw-bolder fs-4 p-3">
          <div className="row mx-0 px-0" dir="ltr">
            <div className="col-auto px-1 align-self-center" dir="rtl">
              <Link
                to={
                  this.props.order.shop
                    ? `/orders/${this.props.order.uid}`
                    : `/dashboard/${this.state.shopUid}/orders/${this.props.order.uid}`
                }
              >
                <button className="btn p-0 color-main fw-bold small">
                  جزئیات
                  <FiChevronLeft className="me-1" size="22" />
                </button>
              </Link>
            </div>
            {this.props.order.medias && (
              <div dir="rtl" className="col align-self-center px-1">
                {this.props.order.medias.map(
                  (media, m) =>
                    m < 3 && (
                      <div className="d-inline-block ms-2">
                        <Image
                          imageUri={media.thumbnail}
                          imageHeight={"40"}
                          imageWidth={"40"}
                          imgClassName={"rounded7 img-cover"}
                          extraClassName={"rounded-circle p-2 bg-color-main"}
                        />
                      </div>
                    )
                )}
                {this.props.order.medias.length > 3 && (
                  <div
                    className="d-inline-block rounded7 border fs-7"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <div className="row mx-0 px-0 h-100">
                      <div className="col px-0 align-self-center text-center text-secondary fw-bold">
                        {this.props.order.medias.length - 3}
                        <FiPlus />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OrderBlock;
